import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import bgImage from "../../assets/bgtruck.svg";
import logo from "../../assets/Logo.svg";
import fb from "../../assets/fb.svg";
import twitter from "../../assets/twitter.svg";
import linkedin from "../../assets/linkedin.svg";
import round from "../../assets/roundtruck.svg";
import eclipse from "../../assets/eclipse.svg";
import Footer from "./Footer";
import { useNavigate, Link } from "react-router-dom";
import Package from "./Package";
import Contact from "./Contact";
import HowLoadboardWorks from "./HowLoadboardWorks";
import { useDashboard } from "../Context/Dashboardcontext";

const HeroSection = () => {
  const navigate = useNavigate();
  const contactRef = useRef(null);
  const [websiteData, setWebsiteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const { FetchDashboardForWebsite, getDashboardForWebsite } = useDashboard();

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    FetchDashboardForWebsite();
  }, []);

  // Fetch Website Data
  useEffect(() => {
    const fetchWebsiteData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/user/getAllWebsite`, {
          headers: { "Content-Type": "application/json" },
        });

        if (response.data?.data) {
          setWebsiteData(response.data.data);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        console.error("API Error:", err.response?.data || err.message);
        setError("Failed to fetch website data.");
      } finally {
        setLoading(false);
      }
    };

    fetchWebsiteData();
  }, [BASE_URL]);

  const authToken = localStorage.getItem("accessToken");

  const countData =
    getDashboardForWebsite?.data
      ? [
        {
          _id: 1,
          title: "Total Containers",
          count: getDashboardForWebsite.data.totalContainer ?? 0,
        },
        {
          _id: 2,
          title: "In Transit",
          count: getDashboardForWebsite.data.totalInTransit ?? 0,
        },
        {
          _id: 3,
          title: "Dispatched",
          count: getDashboardForWebsite.data.totalDispatched ?? 0,
        },
        {
          _id: 4,
          title: "Pending Delivery",
          count: getDashboardForWebsite.data.totalPendingDelivery ?? 0,
        },
      ]
      : [];

  //   if (loading) {
  //     return (
  //       <div className="flex items-center justify-center h-screen">
  //         <div className="flex flex-col items-center">
  //           <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent border-solid rounded-full animate-spin"></div>
  //           <p className="mt-4 text-gray-600 text-lg font-medium">Loading...</p>
  //         </div>
  //       </div>
  //     );
  //   }

  //   if (error) {
  //     return (
  //       <div className="flex items-center justify-center h-screen">
  //         <p className="text-red-500 text-lg font-semibold">{error}</p>
  //       </div>
  //     );
  //   }

  return (
    <>
      <div
        className="relative min-h-screen bg-cover bg-center flex flex-col items-center text-white overflow-x-hidden"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        {/* Top Navbar */}
        <div className="w-full max-w-[100vw] flex flex-col sm:flex-row justify-between items-center px-4 sm:px-6 py-4">
          <div className="flex gap-3 sm:gap-4 text-white text-lg sm:text-xl mb-4 sm:mb-0">
            <img
              src={twitter}
              className="cursor-pointer w-5 h-5 sm:w-6 sm:h-6"
              alt="Twitter"
            />
            <img
              src={fb}
              className="cursor-pointer w-5 h-5 sm:w-6 sm:h-6"
              alt="Facebook"
            />
            <img
              src={linkedin}
              className="cursor-pointer w-5 h-5 sm:w-6 sm:h-6"
              alt="LinkedIn"
            />
          </div>

          <Link
            to="/"
            className="text-white font-bold text-xl sm:text-2xl tracking-wider"
          >
            <img
              src={logo}
              alt="Logo"
              className="w-[120px] sm:w-[150px] md:w-[213px] h-auto mx-auto"
            />
          </Link>

          <div className="flex gap-3 sm:gap-4 mt-4 sm:mt-0">
            <button
              onClick={() => navigate(authToken ? "/dashboard/home" : "/login")}
              className="bg-purple-600 hover:bg-purple-700 text-white text-sm sm:text-base px-3 sm:px-4 py-2 rounded-full w-[80px] sm:w-[100px] font-semibold"
            >
              {authToken ? "Dashboard" : "Log In"}
            </button>
            {!authToken && (
              <button
                onClick={() => navigate("/signup")}
                className="bg-purple-600 hover:bg-purple-700 text-white text-sm sm:text-base px-3 sm:px-4 py-2 w-[80px] sm:w-[100px] rounded-full font-semibold"
              >
                Sign Up
              </button>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="mt-32 sm:mt-48 flex flex-col items-center text-center w-full max-w-[800px] mx-auto px-4 sm:px-0">
          <h1 className="text-[32px] sm:text-[40px] md:text-[60px] font-inter font-bold leading-[1.1] mb-4">
            {websiteData?.title || "Welcome to Dispax"}
          </h1>

          <p className="mb-6 text-[16px] sm:text-[18px] md:text-[25px] text-gray-300 leading-[1.2]">
            {"New technology for TMS software available in USA and Latin America"}
          </p>

          <div className="flex gap-3 sm:gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-[14px] sm:text-[16px] md:text-[19px] text-black p-2 w-[120px] sm:w-[140px] md:w-[160px] rounded-lg font-medium shadow hover:bg-gray-200"
            >
              Contact Us
            </button>
            {/* <button className="text-white text-[14px] sm:text-[16px] md:text-[19px] px-4 sm:px-6 py-2 sm:py-3">
              Learn More
            </button> */}
          </div>
        </div>
        {/* Bottom Stats */}
        {/* <div className="w-full mt-4 max-w-[100vw] flex flex-col sm:flex-row justify-between gap-6 sm:gap-8 md:gap-16 text-left text-white px-4 sm:px-7">
          {Array.isArray(websiteData?.data) &&
            websiteData.data.map((stat) => (
              <div key={stat._id}>
                <h2 className="text-[32px] sm:text-[40px] md:text-[60px] font-bold leading-[1.1]">
                  {stat.count}
                </h2>
                <p className="text-[16px] sm:text-[18px] md:text-[25px]">
                  {stat.title}
                </p>
              </div>
            ))}
        </div> */}
      </div>

      {/* Bottom Sections */}
      {/* <div className="bg-black text-white py-8 sm:py-12 md:py-16 px-4 sm:px-8 md:px-16 overflow-x-hidden">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 md:gap-10 items-start">
          <div>
            <h2 className="text-lg sm:text-xl md:text-[32px] font-semibold mb-4">
              {websiteData?.bottomTitle || ""}
            </h2>
            <p className="text-xs sm:text-sm md:text-[25px] text-gray-300">
              {websiteData?.bottomDescription || ""}
            </p>
          </div>
          <div>
            <p className="text-xs sm:text-sm md:text-base text-gray-400 leading-relaxed">
              {websiteData?.bottomData?.[0]?.title || ""}
            </p>
          </div>
        </div>
      </div> */}

      <div className="bg-black">
        <div className="relative z-10 -mt-48 sm:-mt-72 md:-mt-80 lg:-mt-96 px-4 sm:px-10 md:px-20 pb-12 sm:pb-20">
          <div className="max-w-7xl mx-auto bg-black/20 backdrop-blur-xl border border-white/10 rounded-[30px] p-8 sm:p-12 md:p-16 space-y-8 shadow-[0_8px_32px_rgba(0,0,0,0.5)] text-gray-200">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-4">
              Dispatch Software & Driver App for USA and Latin America
            </h2>
            <div className="h-[2px] bg-purple-600 w-24 mx-auto mb-6 rounded-full"></div>

            <p className="text-base sm:text-lg md:text-xl leading-relaxed text-center text-gray-300">
              <strong>Dispax</strong> is a comprehensive dispatch software solution designed specifically for logistics,
              trucking, and service-based businesses operating in the USA and Latin America. It streamlines operations by
              combining a powerful web-based dispatch platform with a dedicated mobile driver app, enabling seamless
              coordination across borders.
            </p>

            <div className="space-y-6">
              <h3 className="text-xl sm:text-2xl font-semibold text-white border-l-4 border-purple-600 pl-3">
                Key Features
              </h3>

              <ul className="space-y-5 list-disc list-inside text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed">
                <li>
                  <strong className="text-white">Real-Time Dispatching & Routing:</strong><br />
                  Automatically assign jobs to available drivers based on location, availability, and optimal routes.
                  Supports cross-border logistics with multi-language support (English and Spanish) and integration with
                  regional mapping services.
                </li>

                <li>
                  <strong className="text-white">Driver App Functionality:</strong><br />
                  Mobile app for iOS and Android allows drivers to view job details, access navigation, update job
                  status in real-time, and communicate via in-app chat. Includes GPS tracking for ETA predictions and
                  proof-of-delivery tools like photo uploads and e-signatures.
                </li>

                <li>
                  <strong className="text-white">Centralized Dashboard:</strong><br />
                  Web interface for dispatchers to monitor fleet locations, manage schedules, handle customer requests,
                  and generate reports. Features automated notifications for delays, completions, or issues.
                </li>
              </ul>
            </div>
            <div className="bg-transparent overflow-x-hidden text-gray-200">
              <h3 className="text-3xl sm:text-34l font-semibold mb-6 text-white text-center">Benefits</h3>

              <ul className="space-y-5 text-gray-300">
                <li>
                  <strong className="text-white">Efficiency Gains:</strong>
                  <br />
                  Reduce manual scheduling by up to 70% and cut fuel costs through optimized routes.
                </li>

                <li>
                  <strong className="text-white">Improved Visibility:</strong>
                  <br />
                  Track every vehicle in real-time to minimize downtime and enhance customer satisfaction with accurate ETAs.
                </li>

                <li>
                  <strong className="text-white">Cost-Effective:</strong>
                  <br />
                  Affordable subscription model starting for small fleets, with no hidden fees for LATAM expansions.
                </li>

                <li>
                  <strong className="text-white">24/7 Support:</strong>
                  <br />
                  Bilingual customer service team available via chat, email, or phone, ensuring quick resolutions for international users.
                </li>
              </ul>

              <p className="mt-8 text-gray-300 leading-relaxed">
                <strong className="text-white">Dispax</strong> empowers businesses to scale seamlessly from local USA routes to expansive Latin American networks.
                Ready to optimize your dispatch?{" "}
                <span onClick={scrollToContact} className="text-[#B2BAFF] font-semibold hover:underline cursor-pointer">
                  Contact us for a free demo tailored to your operations.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>



      {/* Interactive Truck Section */}
      {/* <div className="relative w-full min-h-[50vh] custom-hide-below-500 sm:min-h-screen bg-black flex items-center justify-center overflow-x-hidden px-4">
        <div className="relative w-full max-w-[100vw] sm:max-w-[1200px] mx-auto">
          {websiteData?.bottomData?.slice(1, 5).map((item, index) => (
            <div key={index} className="absolute z-50 flex items-start space-x-2 w-[80%] sm:w-[40%]">
              <img src={eclipse} alt="orb" className="w-10 h-10 flex-shrink-0" />
              <div className="bg-white bg-opacity-10 text-white text-xs sm:text-sm p-3 sm:p-4 rounded-xl overflow-hidden">
                <p className="line-clamp-2">{item?.title || ""}</p>
              </div>
            </div>
          ))}
          <div className="w-[80vw] sm:w-[50vw] h-[80vw] sm:h-[50vw] max-w-[500px] max-h-[500px] rounded-full overflow-hidden relative z-10 mx-auto">
            <img src={round} alt="truck" className="w-full h-full object-cover" />
          </div>
        </div>
      </div> */}

      {/* Counts */}
      {/* <div className="bg-black text-white py-8 px-4 overflow-x-hidden">
        <div className="flex flex-col sm:flex-row justify-around items-center gap-6 sm:gap-8 max-w-[100vw]">
          {countData?.map((stat) => (
            <div key={stat._id} className="text-center max-w-[80%] sm:max-w-[25%]">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4">{stat.count}</h2>
              <p className="text-xs sm:text-sm md:text-base">{stat.title}</p>
            </div>
          ))}
        </div>
      </div> */}

      {/* About Dispax Powered by Nebudash AI */}
      <div className="bg-black text-white py-16 px-4 sm:px-10 md:px-20">
        <div className="max-w-7xl mx-auto bg-black/20 backdrop-blur-xl border border-white/10 rounded-[30px] p-8 sm:p-12 md:p-16 space-y-12 shadow-[0_8px_32px_rgba(0,0,0,0.5)]">
          {/* Intro */}
          <div className="text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              Dispax + Nebudash AI
            </h2>
            <div className="h-[2px] bg-purple-600 w-24 mx-auto mb-6 rounded-full"></div>
            <p className="text-lg sm:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              A smart logistics platform that connects businesses needing deliveries with available box truck operators and transportation companies already traveling in the same direction. Think of it as an Uber-style marketplace for freight, cargo, pallets, and commercial deliveries.
            </p>
          </div>

          {/* Target Audience & Problems */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="bg-white/5 p-8 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors">
              <h3 className="text-2xl font-semibold mb-4 text-purple-400">Target Audience</h3>
              <p className="text-gray-300 leading-relaxed">
                Distributors, warehouses, manufacturers, wholesalers, and small-to-medium businesses that regularly need products, boxes, pallets, or cargo delivered quickly without paying expensive traditional shipping rates.
              </p>
            </div>
            <div className="bg-white/5 p-8 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors">
              <h3 className="text-2xl font-semibold mb-4 text-purple-400">Key Problems We Solve</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>High shipping costs from traditional carriers.</li>
                <li>Delays in scheduling freight pickups.</li>
                <li>Difficulty finding affordable same-day or on-demand delivery options.</li>
                <li>Empty truck space going unused while businesses need transportation.</li>
              </ul>
            </div>
          </div>

          {/* How it Works */}
          <div>
            <h3 className="text-3xl font-semibold mb-8 text-center text-white">How Dispax Works</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { step: 1, text: "A business requests a pickup or delivery." },
                { step: 2, text: "Nebudash AI instantly finds available carriers and box trucks nearby." },
                { step: 3, text: "The system matches shipments with trucks already traveling in the same route." },
                { step: 4, text: "The cargo gets picked up and delivered quickly and efficiently." },
              ].map((item) => (
                <div key={item.step} className="bg-white/5 p-6 rounded-xl border border-white/10 text-center relative overflow-hidden hover:-translate-y-1 transition-transform cursor-default">
                  <div className="absolute top-[-10px] right-[-10px] text-7xl font-bold text-white/5">{item.step}</div>
                  <h4 className="text-xl font-bold text-purple-400 mb-3">Step {item.step}</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 bg-white/5 p-8 sm:p-10 rounded-2xl border border-white/10">
            <div>
              <h3 className="text-xl sm:text-2xl font-semibold mb-6 text-white border-l-4 border-purple-600 pl-3">Benefits for Businesses</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-3">
                <li>Lower costs than traditional shipping providers.</li>
                <li>Fast, on-demand pickups when needed.</li>
                <li>Reliable delivery of boxes, pallets, and freight.</li>
                <li>Easy scheduling through one platform.</li>
                <li>Greater flexibility for urgent shipments.</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl sm:text-2xl font-semibold mb-6 text-white border-l-4 border-purple-600 pl-3">Benefits for Trucking & Box Truck Companies</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-3">
                <li>Earn additional revenue by filling empty truck space.</li>
                <li>Receive delivery opportunities already on their route.</li>
                <li>Reduce deadhead miles and wasted capacity.</li>
                <li>Access a continuous stream of shipping requests.</li>
              </ul>
            </div>
          </div>

          {/* Message */}
          <div className="bg-gradient-to-r from-purple-900/40 to-black p-8 sm:p-12 rounded-2xl border border-purple-500/30 text-center">
            <p className="text-lg sm:text-xl md:text-2xl text-white italic max-w-5xl mx-auto leading-relaxed">
              "Why pay premium rates when smarter delivery options exist? Dispax, powered by Nebudash AI, connects businesses with available transportation capacity in real time, creating a faster, more affordable way to move cargo. Whether it's a single box, multiple pallets, or commercial freight, Dispax helps businesses ship when they need it while helping carriers maximize every mile."
            </p>
          </div>
        </div>
      </div>

      <HowLoadboardWorks />
      <Package />
      <section ref={contactRef} id="contact">
        <Contact />
      </section>
      <Footer />
    </>
  );
};

export default HeroSection;
